import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import {
    clearAll,
    setErrorMessage,
    setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { AuthAlert } from '../../components';
import AuthFormWrapper from '../../layout/AuthFormWrapper';
import { useNavigate } from 'react-router-dom';
import { appUrls } from '../../../utils/urls/appUrls';

export default function LinkVerificationErrorComponent({formTitle, resendSuccessMessage, activationMessage}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {handleSubmit} = useForm({mode: 'onTouched'})

  const [successMessage, setSuccessMessage] = useState(false)
  const [errorMessage, setCustomErrorMessage] = useState(false)

  const {
        loading,
        errorMsg,
        userTemporaryDetails:{email}
    } = useSelector((state) => state.authData)

    const resendEmail = async () => {
        dispatch(setLoading({loading: false}))
        setSuccessMessage(false)
        setCustomErrorMessage(false)
        const res = await postRequest(
            "",
            `${appApi.resend_verification_link}`,
            {email},
            dispatch,
            setLoading,
            "",
            setErrorMessage
        )
        if(res !== undefined){
            if(res.status < 400){
                navigate(appUrls.emailLinkSuccess)
            } else{
                setCustomErrorMessage(true)
            }
        }
    }     

    const closeErrorAlert = () => {
       setCustomErrorMessage(false)
    }

    const closeSuccessAlert = () => {
        setSuccessMessage(false)
    }

  return (
    <AuthFormWrapper sub_text={formTitle} onHandleSubmit={handleSubmit(resendEmail)} icon="mdi mdi-alert" iconColor="text-danger">
        {successMessage && <AuthAlert onClick={closeSuccessAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='success'>
        {resendSuccessMessage}
        </AuthAlert>}  
      {errorMessage && <AuthAlert onClick={closeErrorAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='error'>
        {errorMsg}
        </AuthAlert>}
        <div className='text-center mb-5 w-100' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>{
            activationMessage == 'invalid link' ? 
            `Your Email Verification link has Expired. You can click on 
            the button below to send the email again` :
            activationMessage
            }</p>
        </div>
      <div className="col-md-12">


        <button type="submit" className="btn btn-primary mb-4">
            Click Here To Send Email Again
        </button>

      </div>        
    </AuthFormWrapper>
  )
}
